import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './users.model';

export const selectUserState = createFeatureSelector<UserState>('users');

export const selectAllUsers = createSelector(selectUserState, state => state.users);
export const selectUserLoading = createSelector(selectUserState, state => state.loading);